import { SecurityGuardInterface } from './guard.interface';
import { SecurityGuardRuleInterface } from './guard/rule.interface';

/**
 * @inheritDoc
 */
export class SecurityGuard implements SecurityGuardInterface {
  /**
   * List of added rules
   */
  private rules: SecurityGuardRuleInterface[] = [];

  /**
   * @inheritDoc
   */
  public addRule(rule: SecurityGuardRuleInterface): void {
    this.rules.push(rule);
  }

  /**
   * @inheritDoc
   */
  public getRules(): SecurityGuardRuleInterface[] {
    return this.rules;
  }

  /**
   * @inheritDoc
   */
  public isAuthorized(): boolean {
    return this.rules.every((rule) => rule.isRespected());
  }
}
